import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlTonality = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <RichTextField
      form={props.form}
      label="Tonality"
      name="tonality"
      userPermissions={props.userPermissions}
      withAdd
    />
  </BorderedBlock>
);
